import React, { useEffect, useState } from 'react';
import SignInWithAncestry from '../components/signInWithAncestry';
import SignInWithFamilySearch from '../components/signInWithFamilySearch';
import useUserContext from '../context/user';

const AUTHORIZED = {
  LOADING: 0,
  UNAUTHORIZED: -1,
  AUTHORIZED: 1,
};

const withAncestry = (Component, type = "ancestry") => {
  const WrappedComponent = props => {
    const userContext = useUserContext();

    const [authorized, setAuthorized] = useState(AUTHORIZED.LOADING);

    useEffect(() => {
      (async () => {
        const { error } = await userContext.ancestryAuth.getToken(type);
        if (error) {
          setAuthorized(AUTHORIZED.UNAUTHORIZED);
        } else {
          setAuthorized(AUTHORIZED.AUTHORIZED);
        }
      })();
    }, [userContext.accessToken]);

    if (authorized === AUTHORIZED.LOADING) {
      return null;
    }

    return (
      <>
        {authorized === AUTHORIZED.UNAUTHORIZED ? (
          <>
            <p className="my-3">
              Your account does not have access to {type === "familysearch" ? "FamilySearch" : "Ancestry"}.
              <br />
              Please use button below to Sign in with your {type === "familysearch" ? "FamilySearch" : "Ancestry"} account.
            </p>
            {type === "familysearch" ? (
              <SignInWithFamilySearch redirectUrl="referer" />
            ) : (
              <SignInWithAncestry redirectUrl="referer" />
            )}
          </>
        ) : (
          <Component {...props} ancestryAuth={userContext.ancestryAuth} />
        )}
      </>
    );
  };

  return WrappedComponent;
};

export default withAncestry;
